import App from "@/views/App.vue";

export default [
  {
    path: "/mensagens",
    name: "chat",
    component: App,
    redirect: { name: "chatHome" },
    children: [
      {
        path: "/chat/:id?",
        name: "chatHome",
        component: () =>
          import(/* webpackChunkName: "chat" */ "../views/ChatList.vue"),
        meta: {
          displayName: "displayName.messages",
          requiresAuth: false,
        },
      },
    ],
  },
];
